import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import FullscreenChartPage from './Page/FullscreenChartPage';
// import './ind.css';


export default function App() {
  const [allData, setAllData] = useState([]); 
  const csrfToken = useSelector((state) => state.csrfToken);

  const fetchSymbolData = async (symbol) => {
    try {
      console.log(` Fetching data for ${symbol}...`);
      
      const apiUrl = `${window.config.base_api_url}/api/usflow?symbol=${symbol}`;
      
      console.log(' API URL:', apiUrl);
      console.log(' CSRF Token:', csrfToken || 'Not available');
      
      const headers = {
        'Content-Type': 'application/json',
        'xsrf-token': csrfToken
      };
      
      if (csrfToken) {
        headers['xsrf-token'] = csrfToken;
      }
      
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: headers,
      });

      console.log(' Response status:', response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error(' Error response:', errorText);
        throw new Error(`Failed to fetch ${symbol}: ${response.status}`);
      }

      const result = await response.json();
      console.log(' Response:', result);
      
      if (result && result.data && Array.isArray(result.data)) {
        console.log(` ${symbol}: ${result.data.length} records`);
        
        const processedData = result.data.map(record => ({
          ...record,
          symbol: result.symbol || symbol,
        }));
        
        return processedData;                   
      }
      
      console.warn(` No data for ${symbol}`);
      return [];
    } catch (error) {
      console.error(` Error fetching ${symbol}:`, error);
      throw error;
    }
  };

  

  console.log(' Rendering app with', allData.length, 'initial records');
  
  
  return <FullscreenChartPage data={allData} onFetchSymbol={fetchSymbolData} />;
}